export const iconFontAwesomeScienceMortarPestle = (
	<i className="fa-solid fa-mortar-pestle"></i>
);
